import { defineMessages } from 'react-intl';

export default defineMessages({
  flaggedComments: 'Flagged Comments',
  surveyTranslations: 'Survey Translations',
  authRoles: 'Roles & Permissions',
  dataSourceLicenses: 'Data Source Licenses',

  exportSurveyTranslations: 'Export',
  importSurveyTranslations: 'Import',
});
